var scope_0 = require('/zeit/6a59ad0a/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6a2d2b2e787b7634b2830f05d1131a38.js').default;export default
        Object.assign({}, scope_0 )
    